import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";
import API from "../../api"; 
import { Outlet, useNavigate } from "react-router-dom";

const CategoriesForm = ({
  open,
  setOpen,
  data,
  isEdit,
  onSubmit,
  parentCategories,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      let response;
      if (isEdit) {
        response = await API.put(`/category/${data?._id}`, values);
        message.success("Category updated successfully!");
        onSubmit({ ...values, _id: data?._id });
      } else {
        response = await API.post(`/category`, values);
        message.success("Category added successfully!");
        onSubmit(response.data);
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error(
        err.response?.data?.message || "Failed to process the request."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button
        type="primary"
        style={{ margin: 10 }}
        onClick={() => navigate("/products/categories")}
      >
        Show Categories
      </Button>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
      >
        {isEdit && (
          <Form.Item name="_id" hidden>
            <Input type="hidden" />
          </Form.Item>
        )}

        <Form.Item
          label="Category Name"
          name="name"
          rules={[
            { required: true, message: "Please enter the category name." },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" block htmlType="submit" loading={isLoading}>
            {isEdit ? "Update Category" : "Add Category"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CategoriesForm;
